import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setProjectManagementMainPage } from '../redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useProjectManagementMainSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getProjectManagementSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website.project_management_main_page.project_management_main_section}`);
      console.log("🚀 ~ getProjectManagementSectionJson ~ data:", response);
      console.log("🚀 ~ getProjectManagementSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setProjectManagementMainPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Project Management section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getProjectManagementSectionJson();
  }, [getProjectManagementSectionJson]);

  return {
    data,
    loading,
    error,
    getProjectManagementSectionJson,
    fetchOnMount,
    refetch: getProjectManagementSectionJson
  };
};

export default useProjectManagementMainSection;
